import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utlilites/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  users: [],
};


const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET spell
    getUsersuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export function getUsers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('character');
      console.log(response,'character--->>>>')
      dispatch(slice.actions.getUsersuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------